import React from 'react';
import { Box, Stack, Typography } from '@mui/material';

const PageHeader = ({ title, subtitle, children, titleVariant = 'h5' }) => (
  <Stack
    direction={{ xs: 'column', sm: 'row' }}
    spacing={1}
    sx={{
      alignItems: { xs: 'flex-start', sm: 'center' },
      justifyContent: 'space-between',
      mb: titleVariant === 'h4' ? 3 : 1.5,
    }}
  >
    <Box>
      <Typography
        variant={titleVariant}
        component="h1"
        sx={titleVariant === 'h4' ? { fontSize: '2rem', lineHeight: 1.2, fontWeight: 500 } : undefined}
      >
        {title}
      </Typography>
      {subtitle && (
        <Typography variant="caption" color="text.secondary" sx={{ mt: 0.25, display: 'block' }}>
          {subtitle}
        </Typography>
      )}
    </Box>
    {children && (
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing={1}
        sx={{
          width: { xs: '100%', sm: 'auto' },
          alignItems: { xs: 'stretch', sm: 'center' },
          '& .MuiFormControl-root': { minWidth: { sm: 200 }, mb: 0 },
          '& .MuiButton-root': { width: { xs: '100%', sm: 'auto' } },
        }}
      >
        {children}
      </Stack>
    )}
  </Stack>
);

export default PageHeader;
